/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use client';

import { useProductView } from '@/providers/product-view';
import { useCurrentVariant } from '@/hooks/product/use-current-variant';
import ApplePayButton from '../apple-pay-button';

/** Native SFCC Apple Pay express checkout for the selected PDP variant. */
export default function CybersourceApplePayPDP() {
    const { product, canAddToCart } = useProductView();
    const currentVariant = useCurrentVariant({ product });
    const productId = currentVariant?.productId || product.id;

    if (!canAddToCart || !productId) return null;
    return <ApplePayButton context="pdp" sku={productId} className="w-full" />;
}
